import React, { useContext} from 'react';
import Spinner from '../../spinner/Spinner';
//import RatingStar from '../../comunes/RatingStar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle/*, faFileDownload*/ } from '@fortawesome/free-solid-svg-icons';
import Swal from 'sweetalert2';
//import * as XLSX from 'xlsx'

import ResultadosContext from '../../../../context/resultados/resultadosContext';


const FinGestion = () => {
    const resultadosContext = useContext(ResultadosContext);
    const { loadingSpinner, finGestion } = resultadosContext;

    //console.log(seguimiento);

    const handleFinGestionDetalle = (item) => {
        //console.log(item);
        try {
            Swal.fire({
                title: item.desc_prc_contacto_largo,
                text: item.desc_prc_email,
                footer: `Gerencia: ${item.desc_prc_area}`,
                confirmButtonColor: '#034673',
                confirmButtonText: 'Volver',
              })
          } catch (error) {
            console.log(error);
            Swal.fire({
              type: 'error',
              title: 'Oops...',
              text: 'Volver a Intentar!',
              //footer: '<a href>Why do I have this issue?</a>'
            })
          }
    }
/*
    const OnClickDownloadFinGestion = () =>{
        let sheetDown = [];
        let extension = '';

        sheetDown = seguimiento;
        extension = 'xlsx';
        
        var wb = XLSX.utils.book_new(),
        ws = XLSX.utils.json_to_sheet(sheetDown);
        XLSX.utils.book_append_sheet(wb, ws, 'MiHoja1');
        XLSX.writeFile(wb, `SeguimientosHistoricos.${extension}`);
        
    }
*/

    return (
        <div className='container'>
                <div className='card borderC-indigo info mb-3'>
                    <div className='card-header resultados-header'>
                    <h4 className='c-indigo'>Se han cerrado {(finGestion ? finGestion.length : null)} casos</h4>
                    <div className='flex-column'>
                        <span className='pr-2'>
                            <FontAwesomeIcon
                                className='c-azulEP'
                                icon={faCircle} size='xs'
                            /> Mes actual
                        </span>
                        <span className='pr-2'>
                            <FontAwesomeIcon
                                className='c-celesteEP'
                                icon={faCircle} size='xs'
                            /> Mes anterior
                        </span>
                        <span className='pr-2'>
                            <FontAwesomeIcon
                                className='c-grisEP'
                                icon={faCircle} size='xs'
                            /> Otros meses
                        </span>
                    </div>
                    {/*<button
                        className='btnCorto btn-primario'
                        data-toggle='tooltip' data-placement='top' title='Descargar Excel'
                        onClick={() => OnClickDownloadOportunidades()}
                    //disabled={btnDisableNuevoMsg}
                    >
                        <FontAwesomeIcon
                            className='btn-table-title-icon mr-2'
                            icon={faFileDownload} size='lg'
                        />Descargar
                    </button>*/}
                </div>
                <div className='card-body'>
                {(loadingSpinner === true) ? (<div className='spinner'><Spinner/></div>) : null}
                    <table className='table table-hover table-responsive'>
                        <thead>
                            <tr>
                            <th scope='col'>Fecha</th>
                            <th scope='col'>Empresa</th>
                            <th scope='col'>Sector</th>
                            <th scope='col'>Nombre Contacto</th>
                            <th scope='col'>Motivo</th>
                            <th scope='col' className='text-center'>Periodo</th>
                            {/*<th scope='col'>Calificación</th>*/}
                            </tr>
                        </thead>
                        <tbody>
                        {(finGestion) ?
                            finGestion.map((item, index) => {
                            return (
                                <tr className='table-light' key={index}>
                                    <td>{item.fecha_opo_entrega}</td>
                                    <th scope='col' onClick={() => handleFinGestionDetalle(item)}>{item.desc_prs_prospecto}</th>
                                    <td>{item.desc_prs_sector}</td>
                                    <td>{item.desc_prc_contacto_largo}</td>
                                    <td>{item.desc_opo_glosa_motivo}</td>
                                    <td className='text-center'>
                                        {
                                            (item.f_opo_mesActual === 2 ) ?
                                            <FontAwesomeIcon
                                                className='c-azulEP'
                                                icon={faCircle} size='lg'
                                            /> : (item.f_opo_mesActual === 1 ) ?
                                            <FontAwesomeIcon
                                                className='c-celesteEP'
                                                icon={faCircle} size='lg'
                                            /> : (item.f_opo_mesActual === 0 ) ?
                                            <FontAwesomeIcon
                                                className='c-grisEP'
                                                icon={faCircle} size='lg'
                                            /> : null
                                        }
                                    </td>
                                    {/*<td>
                                        <RatingStar />
                                    </td>*/}
                                </tr>
                                );
                            })
                        : null}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}

export default FinGestion;
